import * as React from 'react';
import { NavbarElementProps } from 'react-day-picker';

import ArrowLeftIcon from 'vectors/icons/bold-arrow-left.svg';
import ArrowRightIcon from 'vectors/icons/bold-arrow-right.svg';

import { CalendarNavBarContainer, CalendarButton } from './styled';

export const CalendarNavBar: React.FC<NavbarElementProps> = ({
  onNextClick, onPreviousClick,
}) => (
  <CalendarNavBarContainer>
    <CalendarButton
      type="button"
      $iconOnly
      icon={<ArrowLeftIcon />}
      variant="secondary"
      onClick={() => onPreviousClick()}
    />
    <CalendarButton
      type="button"
      $iconOnly
      icon={<ArrowRightIcon />}
      variant="secondary"
      onClick={() => onNextClick()}
    />
  </CalendarNavBarContainer>
);
